module.exports = __webpack_public_path__ + "static/img/Group 7@3x.beac4377.png";